import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { RiskItemInformationsVm } from "@shared/models/policy-details";
import { DataNullDefaultPipe } from "@shared/pipes/data-null-default.pipe";
import { DividerModule } from "primeng/divider";
@Component({
  selector: "app-declaration-sa",
  standalone: true,
  imports: [CommonModule, TranslateModule, DividerModule, DataNullDefaultPipe],
  templateUrl: "./declaration-sa.component.html",
})
export class DeclarationSaComponent implements OnInit {
  @Input() data!: RiskItemInformationsVm;

  itemsToDisplay: { key: string; value: string; displayName: string }[] = [
    { key: "TYPE_ANI", value: "", displayName: "SA_KEYS.TYPE_ANI" },
    { key: "ID_ANI", value: "", displayName: "SA_KEYS.ID_ANI" },
    { key: "SEX_ANI", value: "", displayName: "SA_KEYS.SEX_ANI" },
    { key: "RACE_ANI", value: "", displayName: "SA_KEYS.RACE_ANI" },
    { key: "NOM_ANI", value: "", displayName: "SA_KEYS.NOM_ANI" },
    { key: "DATENAISS_ANI", value: "", displayName: "scholarInsurance.birthDate" },
  ];

  ngOnInit() {
    const valueMap = new Map(this.data.values.map(v => [v.code, v.value]));
    valueMap.forEach((v, k) => {
      if (k!.includes("DATE")) {
        valueMap.set(k, new Date(v).toLocaleDateString());
      }
      if (k!.includes("RACE")) {
        valueMap.set(k, v.charAt(0).toUpperCase() + v.slice(1).toLowerCase());
      }
    });

    this.itemsToDisplay = this.itemsToDisplay.map(k => ({
      ...k,
      value: valueMap.get(k.key) ?? "",
    }));
  }
}
